import React, { useContext } from 'react';
import PostbackPageComponent from './PostbackPage/PostbackPage.container';
import { I18nContext } from 'utils/I18n/context';

const CreatePostbackPage = (props) => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.postbackPage?.creating || { title: 'Create Postback' };

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content tools">
                <div className="ibox postback create-postback">
                    <PostbackPageComponent
                        {...props}
                    />
                </div>
            </section>
        </React.Fragment>
    );
};

CreatePostbackPage.propTypes = {
    // Add any specific props if needed
};

export default CreatePostbackPage;
